/**
 * メニューのカレントページ処理モジュール
 *
 * 現在のページURLとメニューリンクのhrefを比較して、
 * 一致するリンク要素に `is-crntpage` クラスを付与する。
 *
 * @module lib-crntpage
 *
 * @example
 * // app.ts などで以下のようにインポートして使う
 * import './module/lib-crntpage';
 * // このファイル内でinitまで完結しているのでimportするだけでOK！
 */

/**
 * メニューリンクにカレントページクラスを付与する
 *
 * @param {string} [selector='.menu__linksLink a'] - 対象のアンカー要素セレクタ
 * @param {string} [activeClass='is-crntpage'] - 付与するクラス名
 * @returns {void}
 *
 * @example
 * initCrntPage();
 * // セレクタやクラス名をカスタムしたい場合
 * initCrntPage('.my-nav a', 'is-active');
 */
const initCrntPage = (
  selector: string = '.menu__linksLink a',
  activeClass: string = 'is-crntpage'
): void => {
  const currentUrl = window.location.href;
  const links = document.querySelectorAll<HTMLAnchorElement>(selector);

  links.forEach((link) => {
    // 一旦クラスをリセット
    link.classList.remove(activeClass);

    const linkUrl = link.href;

    // トップページの場合は完全一致、それ以外はパス一致で判定
    const isTop =
      linkUrl === `${window.location.origin}/` &&
      currentUrl === `${window.location.origin}/`;

    const isMatch =
      isTop ||
      (linkUrl !== `${window.location.origin}/` &&
        currentUrl.startsWith(linkUrl));

    if (isMatch) {
      link.classList.add(activeClass);
    }
  });
};

// 即時init
initCrntPage();
